import {
  Component,
  EventEmitter,
  Inject,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Claim } from 'src/app/core/models/claim';
import { Contract } from 'src/app/core/models/contract';
import { User } from 'src/app/core/models/user.model';
import { ContractService } from 'src/app/core/services/contract.service';
import { SignedContractService } from 'src/app/core/services/signed_contract.service';
import { UserService } from 'src/app/core/services/user.service';

@Component({
  selector: 'app-eletronic-signature-modal',
  templateUrl: './eletronic-signature-modal.component.html',
  styleUrls: ['./eletronic-signature-modal.component.scss'],
})
export class EletronicSignatureModalComponent implements OnInit {
  @Input() contractId?: string;
  @Input() claimId?: string;
  @Input() componentView = false;

  @Output() onComplete = new EventEmitter();

  template = 'pdf';

  date = new Date();
  user?: User;

  contract?: Contract;
  claim?: Claim;
  url?: string;

  canProceedToSign: boolean = false;

  loading = false;
  // signature flow state passed to child signature-pad
  signatureLoading = false;
  signatureSuccess = false;
  signatureError: string | null = null;
  constructor(
    private userService: UserService,
    private contractService: ContractService,
    private signedContractService: SignedContractService,
    public dialogRef: MatDialogRef<EletronicSignatureModalComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: { contract_id: string; claim_id: string }
  ) {}

  async ngOnInit() {
    if (!!this.claimId && !!this.contractId && this.componentView) {
      this.data.claim_id = this.claimId;
      this.data.contract_id = this.contractId;
    }
    console.log('EletronicSignatureModalComponent -> this', this);
    this.contract = await this.contractService.get(this.data.contract_id);

    console.log('CONTRACT', this.contract);
    if (!this.contract) {
      console.error('Contract not found');
    }
    if (this.contract.configuration.explanation_text) {
      this.changeTemplate('explanation');
    }

    this.url = await this.contractService.getContractDocumentURLById(
      this.contract.id!
    );

    const u = await this.userService.getCurrentUser();
    if (!u) {
      console.error('This screen requires a user.');
      throw new Error('This screen requires a user.');
    }
    this.user = u;
    console.log('USER', this.user);
  }

  changeTemplate(template: string) {
    this.template = template;
  }

  docBundleValid(event: boolean) {
    this.canProceedToSign = event;
  }

  async sendDraw(event: any) {
    // set both modal and child signature state
    this.loading = true;
    this.signatureLoading = true;
    this.signatureSuccess = false;
    this.signatureError = null;
    try {
      console.log('DRAW', event);
      await this.signedContractService.doSign(
        this.contract!.id!,
        this.data.claim_id,
        event,
        this.userService.getFingerprint(),
        '000.000.000.000'
      );

      // this.scs.create({
      //   claim_id: this.data.claim_id,
      //   contract_id: this.contract?.id,
      //   status: 'PENDING',
      //   user_agent: this.us.getFingerprint(),
      //   signer_id: this.user?.id,
      //   signature_data: {
      //     claim_id: this.data.claim_id,
      //     contract_id: this.data.contract_id,
      //     qrcode_info: {
      //       full_legal_name: this.user?.display_name!,
      //       ip: '123.32.212.55',
      //     },
      //     signature_bytes: event,
      //     user_agent: this.us.getFingerprint(),
      //   },
      // });
      // this.changeTemplate('error');
      this.signatureSuccess = true;
      this.changeTemplate('sucess');
    } catch (error) {
      console.error('ERROR ON ElectronicSignatureModalComponent', error);
      // try to extract a friendly message
      const message =
        (error && (error as any).error.message) ||
        (error && (error as any).message) ||
        'Erro ao assinar o documento. Por favor, tente novamente.';
      this.signatureError = message;
      // switch to error template so user sees details
      // this.changeTemplate('error');
    } finally {
      this.loading = false;
      this.signatureLoading = false;
    }
  }

  close() {
    if (this.componentView) {
      this.onComplete.next(true);
    } else {
      this.dialogRef.close();
    }
  }
}
